import { createFileRoute } from '@tanstack/react-router';

import { PredictionPage } from '@/features/prediction/PredictionPage';
import { isMarket, type Market } from '@/lib/market/types';

/**
 * `/:market/securities/:symbol/ai/prediction` —— 個股的冠軍模型分數卡（ARCHITECTURE §10.1）。
 *
 * 路徑與後端 `metric_resolver.href_template()` 對 `category='model'` 給的目的地逐字相同，
 * 所以側邊欄 registry 那一列、SHAP 驅動因子的連結與這條路由是同一個字串。
 * `?as_of` 在 `__root.tsx` 宣告，這裡繼承——分數卡跟著時光機一起倒帶。
 */
export const Route = createFileRoute('/$market/securities/$symbol/ai/prediction')({
  component: PredictionRoute,
});

function PredictionRoute() {
  const { market: rawMarket, symbol } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';
  return <PredictionPage market={market} symbol={symbol} />;
}
